import { combineReducers } from '@reduxjs/toolkit';
import  {connectRouter} from 'connected-react-router';
import { History } from 'history';
import { reducer as oidcReducer } from 'redux-oidc';
import apiReducer from './apiSlice';
import selectFilterReducer from 'features/selectFilter/selectFilterSlice';
import imageListReducer from 'features/imageList/imageListSlice';
import fileUploadReducer from 'features/fileUpload/fileUploadSlice';
import userManagementReducer  from 'features/userManagement/userManagementSlice';

const createRootReducer = (history: History) => combineReducers({
    oidc: oidcReducer,
    api: apiReducer,
    selectFilter: selectFilterReducer,
    imageList: imageListReducer,
    uploads: fileUploadReducer,
    userManagement: userManagementReducer,
    router: connectRouter(history)
});
export type RootState = ReturnType<ReturnType<typeof createRootReducer>>;
export default createRootReducer;